module.exports = __webpack_public_path__ + "img/theme3.dd61734a.png";